// ===============================
// DEFAULT ABOUT PAGE DATA
// ===============================
export const aboutData = {
  subtitle: "OUR MISSION",
  title: "ADVANCING THE STANDARD OF MODERN FINANCIAL ADVISORY",

  rightText:
    "We exist to strengthen how organizations interpret financial risk, capitalize on opportunity, and build long-term value. Our mission is rooted in analytical depth, strategic discipline, and the belief that better decisions shape stronger economies and more resilient businesses.",

  box1Title: "Decision Reinvention",
  box1Text:
    "We aim to elevate financial decision-making through advanced modeling, cross-market intelligence, and scenario-driven evaluation.",

  box2Title: "Resilience Engineering",
  box2Text:
    "Our mission focuses on embedding stability, performance discipline, and risk foresight into the core of every organization we support.",

  image: "/assets/images/TeamMeeting.png",
};

// ===============================
// SERVICES PAGE DATA SEPARATED BY PATH
// ===============================

// 1️⃣ FINANCIAL STATEMENT AUDIT
export const financialStatementAuditData = {
  subtitle: "UNDERSTANDING FINANCIAL STATEMENT AUDITS",
  title: "RELIABLE REPORTING FOR BUSINESSES THAT NEED ABSOLUTE ACCURACY",

  rightText:
    "Our audits uncover inconsistencies behind the numbers, assess control gaps, and provide a clear, defensible view of your organization’s financial position.",

  box1Title: "AT PESTEL & PARTNERS",
  box1Text:
    "Our Financial Statement Audit service is designed to validate accuracy, fairness, and compliance of financial information.",

  box2Title: "OUR EXPERIENCED AUDITORS",
  box2Text:
    "We strengthen weak processes and ensure your statements meet IFRS, GAAP, and all regulatory expectations without surprises.",

  image: "/assets/images/TeamMeeting.png",
};

// 2️⃣ IFRS ADVISORY SERVICES
export const ifrsAdvisoryServiceData = {
  subtitle: "ABOUT IFRS SERVICE",
  title: "ACCURATE, COMPLIANT & GLOBALLY ALIGNED REPORTING",

  rightText:
    "We help organizations interpret IFRS requirements, redesign reporting structures, and prepare regulator-ready disclosures.",

  box1Title: "AT PESTEL & PARTNERS",
  box1Text:
"Our motive is to help organizations interpret IFRS requirements, redesign financial reporting structures, and prepare disclosures that satisfy regulators, investors. ",
  box2Title: "OUR IFRS SPECIALISTS",
  box2Text:"Our experienced professionals bring deep expertise across IFRS transitions, new standard adoption, complex transactions, and various accounting treatments. ",

  image: "/assets/images/TeamMeeting.png",
};

// 3️⃣ OTHER ASSURANCE SERVICES
export const otherAssuranceServiceData = {
  subtitle: "ABOUT THIS SERVICE",
  title: "STRENGTHENING TRUST BEYOND FINANCIAL STATEMENTS",

  rightText:
    "We evaluate systems, controls, and performance indicators that influence integrity, compliance standing, and reporting quality.",

  box1Title: "AT PESTEL & PARTNERS",
  box1Text:
    "We evaluate system, controls, and performance indicators that influence operational integrity, compliance standing, and reporting quality. ",

  box2Title: "OUR EXPERIENCED PROFESSIONALS",
  box2Text:
    "Our specialists combine sector expertise with deep assurance experience to assess processes with precision, identify gaps, and deliver clear results. ",

  image: "/assets/images/TeamMeeting.png",
};

// 4️⃣ INTERNAL CONTROL FRAMEWORK
export const internalControlFrameworkData = {
  subtitle: "WHY STRONG CONTROLS MATTER",
  title: "BECAUSE RISK SURFACES WHERE CONTROLS DON’T",

  rightText:
    "We design control environments that reflect real processes, real roles, and real risks—never textbook assumptions.",

  box1Title: "AT PESTEL & PARTNERS",
  box1Text:
    "We design control environments that reflect real processes, real roles, and real risk exposure, not textbook assumptions. ",

  box2Title: "OUR EXPERIENCED SPECIALISTS",
  box2Text:
    "We identify inefficiencies, automate controls where possible, and turn governance into a scalable strength instead of a compliance burden.",

  image: "/assets/images/TeamMeeting.png",
};
export const dealAdvisoryData = {
  subtitle: "UNDERSTAND VALUE BEYOND NUMBERS",
  title: "DEAL STRUCTURING, M&A STRATEGY & COMMERCIAL CLARITY",

  rightText:
    "We analyze commercial viability, forecast value upside, and uncover risks that influence your final decision, helping you negotiate confidently.",

  box1Title: "AT PESTEL & PARTNERS",
  box1Text:
    "We analyze commercial viability, forecast value upside, and uncover risks that influence your final decision, helping you negotiate confidently.",

  box2Title: "OUR ADVISORY APPROACH",
  box2Text:
    "Our experts combine financial analytics + industry intuition to help you identify the right targets, unlock synergies, and exit at the best valuation.",

  image: "/assets/images/TeamMeeting.png",
};
export const restructuringData = {
  subtitle: "RESTRUCTURING WITH DISCIPLINE",
  title: "WHEN A BUSINESS NEEDS MORE THAN OPTIMISM",

  rightText:
    "We step in when growth slows, debt piles up, margins shrink, and decision-making becomes reactive by building a turnaround plan grounded in numbers, not hope.",

  box1Title: "AT PESTEL & PARTNERS",
  box1Text:
    "We step in when growth slows, debt piles up, margins shrink, and decision-making becomes reactive by building a turnaround plan grounded in numbers, not hope.",

  box2Title: "OUR RESTRUCTURING SPECIALISTS",
  box2Text:
    "We balance creditor expectations, cash urgency, workforce impact, and business continuity to stabilize operations before driving long-term recovery.",

  image: "/assets/images/TeamMeeting.png",
};
export const dueDiligenceData = {
  subtitle: "WHY DUE DILIGENCE MATTERS",
  title: "DECISIONS ARE AS STRONG AS THE INFORMATION",

  rightText:
    "We decode financial realities, validate business fundamentals, test assumptions, and uncover red flags early - so confidence doesn’t come at a cost later.",

  box1Title: "AT PESTEL & PARTNERS",
  box1Text:
    "We decode financial realities, validate business fundamentals, test assumptions, and uncover red flags early - so confidence doesn’t come at a cost later.",

  box2Title: "INDEPENDENT EVALUATION YOU CAN TRUST",
  box2Text:
    "Our experts don’t skim data; they interrogate it. Every number, claim, and projection is stress-tested to reveal truth, not theory.",

  image: "/assets/images/TeamMeeting.png",
};
export const forensicServicesData = {
  subtitle: "ABOUT FORENSIC SERVICES",
  title: "UNCOVERING FRAUD & FINANCIAL MISREPRESENTATION",

  rightText:
    "We review financial records, conduct interviews, access digital logs, and reconstruct events to understand what happened, when, and how.",

  box1Title: "AT PESTEL & PARTNERS",
  box1Text:
    "We review financial records, conduct interviews, access digital logs, and reconstruct events to understand what happened, when, and how.",

  box2Title: "OUR FORENSIC SPECIALISTS",
  box2Text:
    "Professionals trained in investigation, compliance & technology-assisted audits to detect fraud schemes before they grow into business-threatening losses.",

  image: "/assets/images/TeamMeeting.png",
};
export const riskAdvisoryData = {
  subtitle: "ABOUT RISK ADVISORY",
  title: "WE TURN UNCERTAINTY INTO STRATEGIC AWARENESS",

  rightText:
    "Our risk advisory practice reviews processes, regulatory exposure, operational gaps, cyber vulnerabilities & financial impact to uncover threats.",

  box1Title: "AT PESTEL & PARTNERS",
  box1Text:
    "Our risk advisory practice reviews processes, regulatory exposure, operational gaps, cyber vulnerabilities & financial impact to uncover threats.",

  box2Title: "OUR RISK EXPERTS",
  box2Text:
    "Professionals with cross-industry exposure skilled in enterprise risk frameworks, controls, stress testing & response preparedness.",

  image: "/assets/images/TeamMeeting.png",
};
export const technologyAdvisoryServiceData = {
  subtitle: "ABOUT TECH ADVISORY",
  title: "TECHNOLOGY THAT WORKS WITH YOUR BUSINESS",

  rightText:
    "We decode technology challenges, map inefficiencies, modernize legacy architecture, and align tech spend with enterprise values.",

  box1Title: "AT PESTEL & PARTNERS",
  box1Text:
    "We decode technology challenges, map inefficiencies, modernize legacy architecture, and align tech spend with enterprise values.",

  box2Title: "OUR TECHNOLOGY EXPERTS",
  box2Text:
    "Strategists experienced in digital transformation, ERP selection, cloud migration, cybersecurity frameworks, process automation and data-driven decision models.",

  image: "/assets/images/TeamMeeting.png",
};
export const valuationsData = {
  subtitle: "OUR VALUATION EXPERTISE",
  title: "STRONG DECISIONS & CONFIDENT DEALS",

  rightText:
    "We decode revenue streams, risk exposure, cash flow resilience, and market dynamics to present a valuation that reflects real business strength.",

  box1Title: "AT PESTEL & PARTNERS",
  box1Text:
    "We decode revenue streams, risk exposure, cash flow resilience, and market dynamics to present a valuation that reflects real business strength.",

  box2Title: "OUR VALUATION SPECIALISTS",
  box2Text:
    "Our experts apply globally recognized valuation models and scenario-based analysis, ensuring every figure is audit-ready and negotiation-strong.",

  image: "/assets/images/TeamMeeting.png",
};
export const corporateTaxData = {
  subtitle: "MASTERING TAX STRATEGY",
  title: "CORPORATE TAX BUILT TO PROTECT & SCALE",
  rightText:
    "We don’t just calculate numbers; we identify tax positions, incentives, restructuring avenues, and deduction pathways that actively reduce your payable load.",
  box1Title: "AT PESTEL & PARTNER",
  box1Text:
    "We don’t just calculate numbers; we identify tax positions, incentives, restructuring avenues, and deduction pathways that actively reduce your payable load.",
  box2Title: "OUR TAX SPECIALISTS",
  box2Text:
    "Our corporate tax advisors come with multi-industry experience, ensuring every decision is backed by legal interpretation, risk foresight and structured documentation.",
  image: "/assets/images/TeamMeeting.png",
};

export const mergerAndAcquisitionData = {
  subtitle: "LEARNING MERGER & ACQUISITION",
  title: "TAX-EFFICIENT MERGERS & ACQUISITIONS",
  rightText:
    "We assess acquisitions, divestments, and reorganizations through a tax lens so no hidden liability surfaces later.",
  box1Title: "AT PESTEL & PARTNERS",
  box1Text:
    "We assess acquisitions, divestments, and reorganizations through a tax lens so no hidden liability surfaces later.",
  box2Title: "OUR TAX EXPERTISE",
  box2Text:
    "Our consultants have worked across industries, giving us foresight into compliance challenges and integration models that protect financial outcomes.",
  image: "/assets/images/TeamMeeting.png",
};

export const transferPricingData = {
  subtitle: "UNDERSTANDING TRANSFER PRICING",
  title: "TAX-EFFICIENT PRICING FOR GLOBAL TRANSACTIONS",
  rightText:
    "We analyze global entity relationships, functions, rights, and risk allocation to design pricing that stands up to both audits and economic reality.",
  box1Title: "Pestel & Partners",
  box1Text:
    "We analyze global entity relationships, functions, rights, and risk allocation to design pricing that stands up to both audits and economic reality.",
  box2Title: "Our Transfer Pricing Experts",
  box2Text:
    "We benchmark comparable market behaviour, structure documentation under OECD/Economic regulations, and support representation across jurisdictions.",
  image: "/assets/images/TeamMeeting.png",
};

export const valueAddedTaxData = {
  subtitle: "SERVICE INSIGHT",
  title: "VAT ADVISORY BUILT ON LEGISLATION",
  rightText:
    "We translate VAT laws into business-ready frameworks — from registrations and supply chain mapping to zero-rating eligibility.",
  box1Title: "At Pestel & Partners",
  box1Text:
    "We translate VAT laws into business-ready frameworks — from registrations and supply chain mapping to zero-rating eligibility.",
  box2Title: "Our Tax Specialists",
  box2Text:
    "Work across sectors including retail, trading, logistics, e-commerce, manufacturing and real estate, ensuring implementation is compliant.",
  image: "/assets/images/TeamMeeting.png",
};

export const internationalTaxData = {
  subtitle: "GLOBAL TAX. LOCAL PRECISION.",
  title: "WE BRING STRUCTURE TO CROSS-BORDER TAXATION",
  rightText:
    "We support global businesses with tax frameworks that reduce exposure, increase certainty, and align with evolving international standards.",
  box1Title: "At Pestel & Partners",
  box1Text:
    "We support global businesses with tax frameworks that reduce exposure, increase certainty, and align with evolving international standards.",
  box2Title: "Our International Tax Experts",
  box2Text:
    "Advisors skilled in treaties, BEPS norms, permanent establishment evaluation, and foreign transaction compliance.",
  image: "/assets/images/TeamMeeting.png",
};

export const exciseTaxData = {
  subtitle: "UNDERSTANDING YOUR TAX BURDEN",
  title: "EXCISE COMPLIANCE THAT COSTS NO ERROR",
  rightText:
    "We decode excise rules for your industry — fuels, tobacco, carbon-related goods or special rate items, so liability becomes predictable, not overwhelming.",
  box1Title: "At Pestel & Partners",
  box1Text:
    "We decode excise rules for your industry — fuels, tobacco, carbon-related goods or special rate items, so liability becomes predictable, not overwhelming.",
  box2Title: "Our Excise Specialists",
  box2Text:
    "Years of regulatory exposure allow us to defend your position, reduce risk, and prepare you for audits before they occur.",
  image: "/assets/images/TeamMeeting.png",
};

export const taxRestructuringData = {
  subtitle: "RESTRUCTURE WITH CLARITY",
  title: "TAX MODELS THAT REDUCE EXPOSURE & RECOVER VALUE",
  rightText:
    "We evaluate entity structure, flow of transactions, cross-border rules & tax leakages — then rebuild a system that’s efficient, compliant, and future-scaled.",
  box1Title: "At Pestel & Partners",
  box1Text:
    "We evaluate entity structure, flow of transactions, cross-border rules & tax leakages — then rebuild a system that’s efficient, compliant, and future-scaled.",
  box2Title: "Our Restructuring Specialists",
  box2Text:
    "Experts with domain exposure across M&A, holding structures, cross-jurisdiction planning & re-classification strategies for tax-lean operations.",
  image: "/assets/images/TeamMeeting.png",
};

export const economicSubstanceRegulationsData = {
  subtitle: "BUILT FOR REGULATORY PROOF",
  title: "DEMONSTRATING GENUINE OPERATIONAL SUBSTANCE",
  rightText:
    "We review your UAE business model, board controls, income streams & operational footprint to assess compliance under ESR law.",
  box1Title: "At Pestel & Partners",
  box1Text:
    "We review your UAE business model, board controls, income streams & operational footprint to assess compliance under ESR law.",
  box2Title: "Our Compliance Experts",
  box2Text:
    "Skilled in ESR evaluations, filing, notification, gap analysis & board-level documentation that stands sound during authority review.",
  image: "/assets/images/TeamMeeting.png",
};
export const financeAndAccountingData = {
  subtitle: "WHERE CLARITY MEETS CONTROL",
  title: "END-TO-END ACCOUNTING FOR QUICK SOLUTIONS",
  rightText:
    "At Pestel & Partners \n\nWe streamline accounts, automate daily tasks, organize financial flow, and ensure every number lands where it should.",
  box1Title: "At Pestel & Partners",
  box1Text:
    "We streamline accounts, automate daily tasks, organize financial flow, and ensure every number lands where it should.",
  box2Title: "Our Experienced Accountants",
  box2Text:
    "A team trained to deliver audit-ready books, razor-sharp reporting, and actionable visibility so you never lose track of cash, cost, or compliance.",
  image: "/assets/images/TeamMeeting.png",
};
export const corporateAdvisoryServicesData = {
  subtitle: "WHY CORPORATE ADVISORY MATTERS",
  title: "SMART DECISIONS NEED STRONG PERSPECTIVE",
  rightText:
    "At Pestel & Partners \nWe guide businesses through decisions that impact capital structure, expansion, partnerships, and long-term profitability.",
  box1Title: "At Pestel & Partners",
  box1Text:
    "We guide businesses through decisions that impact capital structure, expansion, partnerships, and long-term profitability.",
  box2Title: "Our Experienced Advisors",
  box2Text:
    "Decades of working with regional and global corporates make us quick to understand challenges, even quicker to identify opportunities.",
  image: "/assets/images/TeamMeeting.png",
};
export const expensesClaimManagementData = {
  subtitle: "YOUR TRUSTED EXPENSE PARTNER",
  title: "A CLEAR, COMPLIANT CLAIM SYSTEM",
  rightText:
    "At Pestel & Partners \n\nWe streamline your organizational expense workflow with accurate validation checks and automated tracking to reduce delays and reimburse employees faster.",
  box1Title: "At Pestel & Partners",
  box1Text:
    "We streamline your organizational expense workflow with accurate validation checks and automated tracking to reduce delays and reimburse employees faster.",
  box2Title: "Our Expense Specialists",
  box2Text:
    "Our team brings deep expertise in compliance, documentation, and cost control, ensuring every claim passes through robust verification.",
  image: "/assets/images/TeamMeeting.png",
};
export const payrollHrServicesData = {
  subtitle: "WHAT THIS SERVICE DELIVERS",
  title: "COMPLETE PAYROLL & HR ADMINISTRATION",
  rightText:
    "At Pestel & Partners \nWe handle everything from payroll processing and statutory compliance to HR documentation, benefits management, and leave administration.",
  box1Title: "At Pestel & Partners",
  box1Text:
    "We handle everything from payroll processing and statutory compliance to HR documentation, benefits management, and leave administration.",
  box2Title: "Our People Operations Specialists",
  box2Text:
    "Our experienced payroll and HR professionals bring deep regulatory knowledge, secure processes, and dependable support to operate with confidence and consistency.",
  image: "/assets/images/TeamMeeting.png",
};
export const secondmentData = {
  subtitle: "STRATEGIC WORKFORCE EXTENSION",
  title: "ON-DEMAND EXPERTS IN YOUR TEAM",
  rightText:
    "At Pestel & Partner \n\nWe embed professionals who stabilize processes, uplift output quality, and integrate into your workflows with in-house employee accountability and external specialist expertise.",
  box1Title: "At Pestel & Partner",
  box1Text:
    "We embed professionals who stabilize processes, uplift output quality, and integrate into your workflows with in-house employee accountability and external specialist expertise.",
  box2Title: "Our Skilled Specialists",
  box2Text:
    "Every secondee is rigorously checked for technical capability, adaptability, and industry fluency, ensuring they can assume responsibility instantly.",
  image: "/assets/images/TeamMeeting.png",
};
export const treasuryServiceData = {
  subtitle: "WHO WE ARE",
  title: "A TREASURY PARTNER THAT UNDERSTANDS VOLATILITY",
  rightText:
    "At Pestel & Partners \n\nWe create treasury frameworks that help organizations navigate currency shifts, liquidity demands, and cross-border cash movements.",
  box1Title: "At Pestel & Partners",
  box1Text:
    "We create treasury frameworks that help organizations navigate currency shifts, liquidity demands, and cross-border cash movements.",
  box2Title: "Our Treasury Specialists",
  box2Text:
    "Our team brings deep banking, finance, and compliance expertise — ensuring your treasury operates with accuracy, foresight, and strong internal controls.",
  image: "/assets/images/TeamMeeting.png",
};
// STRATEGIES
export const marketResearchData = {
  subtitle: "HOW MARKET RESEARCH HELPS",
  title: "STRATEGIES RESEARCH FOR REAL BUSINESS DECISIONS",
  rightText:
    "At Pestel & Partners \n\nWe combine data analytics, industry intelligence, and on-ground research to help organizations understand markets, customers, and competitive landscapes.",
  box1Title: "At Pestel & Partners",
  box1Text:
    "We combine data analytics, industry intelligence, and on-ground research to help organizations understand markets, customers, and competitive landscapes.",
  box2Title: "Our Research Specialists",
  box2Text:
    "Our analysts, economists, and sector experts decode trends, quantify opportunities, and uncover risks, enabling you to act with clarity, not guesswork.",
  image: "/assets/images/TeamMeeting.png",
};

export const businessConsultingData = {
  subtitle: "OUR STRATEGIC EXPERTISE",
  title: "PRACTICAL ADVISORY FOR LEADERS WHO NEED RESULTS",
  rightText:
    "At Pestel & Partners \n\nWe help leadership teams make sense of evolving markets, operational bottlenecks, and shifting customer needs—turning uncertainty into clear, actionable direction.",
  box1Title: "At Pestel & Partners",
  box1Text:
    "We help leadership teams make sense of evolving markets, operational bottlenecks, and shifting customer needs—turning uncertainty into clear, actionable direction.",
  box2Title: "Our Consulting Specialists",
  box2Text:
    "Decades of cross-industry expertise allow us to diagnose what’s holding your growth back and design strategic frameworks built around competitive strength.",
  image: "/assets/images/TeamMeeting.png",
};

// CORPORATE SERVICES
export const entitySetupData = {
  subtitle: "BUILT RIGHT FROM BEGINNING",
  title: "END-TO-END ENTITY FORMATION WITH ZERO GUESSWORK",
  rightText:
    "At Pestel & Partners \n\nWe turn the complexity of entity formation into a clear, strategic journey. Instead of drowning you in regulations, we decode them!",
  box1Title: "At Pestel & Partners",
  box1Text:
    "We turn the complexity of entity formation into a clear, strategic journey. Instead of drowning you in regulations, we decode them!",
  box2Title: "Our Corporate Advisors",
  box2Text:
    "Our advisors step in as your strategic partners, not document processors. They study how you plan to operate, scale, hire, transact, and expand internationally.",
  image: "/assets/images/TeamMeeting.png",
};

export const outsourcedFinanceRegulatoryComplianceData = {
  subtitle: "A STRONGER FINANCIAL BACKBONE",
  title: "BUILT ON ACCURACY & CONTINUOUS COMPLIANCE",
  rightText:
    "At Pestel & Partner \n\nWe take over the operational load with a system-driven approach that keeps your numbers clean, timely, and aligned.",
  box1Title: "At Pestel & Partner",
  box1Text:
    "We take over the operational load with a system-driven approach that keeps your numbers clean, timely, and aligned.",
  box2Title: "Our Regulatory Experts",
  box2Text:
    "Our team monitors evolving laws, manages documentation, and ensures your business never misses an obligation.",
  image: "/assets/images/TeamMeeting.png",
};

export const companySecretarialData = {
  subtitle: "YOUR CORPORATE GOVERNANCE BACKBONE",
  title: "KEEPING YOUR CORPORATE HOUSE IN PERFECT ORDER",
  rightText:
    "At Pestel & Partners \n\nWe manage your entire corporate compliance lifecycle—from incorporations and amendments to registers, resolutions, and regulatory filings.",
  box1Title: "At Pestel & Partners",
  box1Text:
    "We manage your entire corporate compliance lifecycle—from incorporations and amendments to registers, resolutions, and regulatory filings.",
  box2Title: "Our Governance Specialists",
  box2Text:
    "Our team brings practical regional experience, deep regulatory understanding, and meticulous documentation skills to maintain your entity’s statutory integrity.",
  image: "/assets/images/TeamMeeting.png",
};
